import React, { useEffect } from "react";

// import redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { auditMembersCloseAction } from "../features/sliceReducer/interactionReducer";

//import material-UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  TextField,
  Paper,
  Typography,
  InputLabel,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { addAuditMemberAction } from "../features/sliceReducer/projectReducer";
import { IPAuditMember } from "../models/IPAuditMember";

//material-UI-Style

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1200px",
      height: "840px",
      overflowY: "auto",

      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      margin: "0 auto",
    },
    labelAlign: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "8px 0 8px 12px",

      "& > label": {
        width: "10%",
        fontWeight: "bold",
      },
      "& > div": {
        flexGrow: 1,
      },
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
  })
);

interface AuditModalProps {
  auditMember: IPAuditMember;
}

const AuditModal = (props: AuditModalProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<IPAuditMember>();

  useEffect(() => {
    reset(props.auditMember);
  }, [props]);

  const { auditMembersToggle } = useSelector(
    (state: RootState) => state.interaction
  );

  const onSubmit: SubmitHandler<IPAuditMember> = (data: IPAuditMember) => {
    dispatch(addAuditMemberAction(data));
    reset();
    dispatch(auditMembersCloseAction());
    // console.log(data);
  };

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={auditMembersToggle}
        onClose={() => {
          dispatch(auditMembersCloseAction());
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={auditMembersToggle}>
          <Box component={Paper} className={classes.paper}>
            <Typography
              className={classes.modalTitle}
              variant="h5"
              component="h5"
            >
              감사팀의 구성
            </Typography>
            <form className={classes.container}>
              <Box className={classes.labelAlign}>
                <InputLabel>성명 :</InputLabel>
                <Controller
                  name="name"
                  control={control}
                  defaultValue={props.auditMember.name}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      {...register("name", { required: "성명을 입력해 주세요." })}
                      id="name"
                      required
                      label="성명"
                      multiline
                      variant="outlined"
                      margin="normal"
                      error={errors.name ? true : false}
                    />
                  )}
                />
              </Box>
              <Box pl="120px">
                <Typography variant="inherit" color="secondary">
                  {errors.name?.message}
                </Typography>
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>소속/지위 :</InputLabel>
                <Controller
                  name="department"
                  control={control}
                  defaultValue={props.auditMember.department}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      {...register("department")}
                      id="department"
                      label="소속/지위"
                      multiline
                      variant="outlined"
                      margin="normal"
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>직책/경력 :</InputLabel>
                <Controller
                  name="position"
                  control={control}
                  defaultValue={props.auditMember.position}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      {...register("position")}
                      id="position"
                      label="감사상 직책/경력"
                      multiline
                      variant="outlined"
                      margin="normal"
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>감사내용 :</InputLabel>
                <Controller
                  name="duty"
                  control={control}
                  defaultValue={props.auditMember.duty}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      {...register("duty")}
                      id="duty"
                      label="주요 감사내용"
                      multiline
                      variant="outlined"
                      margin="normal"
                    />
                  )}
                />
              </Box>
              <Box mt={4} mb={4} textAlign="center">
                <Button
                  style={{ width: "120px", height: "48px" }}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  정보 저장
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
};

export default AuditModal;
